<template>
    <div>
        <div class="re-container flex column">
            <re-nav-bar v-on:app="scroll_to('re-the-applciation')"></re-nav-bar>
            <div class="flex column re-spacing">
                <div class="flex center">
                     <div class="flex-1 lg-container">
                    </div>
                    <div class="flex column wrap">
                        <div class="re-pgnum">
                            <img :src="require('../../assets/Desktop/About_Us/00-img.svg')" alt="Home Page 0">
                        </div>
                        <div>
                            <p class="re-subtitle">FULL SERVICE</p>
                        </div>
                        <div>
                            <h1 class="re-title">Full-Service <br/> Concierge and Hospitality</h1>
                        </div>
                        <div>
                            <p class="re-text">We at Royal Experience are dedicated to be the global leader in providing businesses and individuals the most convenient, efficient, and exclusive luxury concierge / hospitality services through digital technology.</p>
                        </div>
                        <re-form class="form"></re-form>
                    </div>
                    <div class="flex-1 flex vertical-center center lg-container">
                        <re-panel-nav 
                            v-on:app="scroll_to('re-the-applciation')"
                            v-on:offer="scroll_to('re-the-offering')"
                            v-on:company="scroll_to('re-company-breakdown')"
                            class="re-panel-nav">
                        </re-panel-nav>
                    </div>
                </div>
            </div>
        </div>
        <div ref="re-company-breakdown">
            <re-company-breakdown
                v-on:scroll_location="get_nav"     
            >
            </re-company-breakdown>
        </div>
        <div ref="re-the-offering">
            <re-the-offering
               v-on:scroll_location="get_nav"  
            >
            </re-the-offering>
        </div>
        <div ref="re-the-applciation">
            <re-the-applciation
               v-on:scroll_location="get_nav"  
            >
            </re-the-applciation>
        </div>
        <re-our-team></re-our-team>
        <re-footer
            v-on:app="scroll_to('re-the-applciation')"
            v-on:offer="scroll_to('re-the-offering')"
            v-on:company="scroll_to('re-company-breakdown')"
        >
        </re-footer>
         
    </div>
</template>

<script>
    import Company_Breakdown from './Company_Breakdown.vue'
    import The_Offering from './The_Offering.vue'
    import The_Application from './The_Application.vue'
    import Our_Team from './Our_Team.vue'
    import Footer from '../Footer.vue'
    import Panel_Nav from './Panel_Nav.vue'
    import Nav_Bar from '../Nav_Bar.vue'
    import Form from '../Form.vue'

    export default {
        data: () => ({
            scroll_location: ''
         }),
        components: {
            're-company-breakdown': Company_Breakdown,
            're-the-offering': The_Offering,
            're-the-applciation': The_Application,
            're-our-team': Our_Team,
            're-footer': Footer,
            're-panel-nav': Panel_Nav,
            're-nav-bar': Nav_Bar,
            're-form': Form
        },
        methods: {
            scroll_to(refName) {
    	        let element = this.$refs[refName];
                let top = element.offsetTop;
                window.scrollTo(0, top);
            },
            get_nav(value){
                this.scroll_to(value)
            }
        }
    }
    
</script>

<style scoped>
    @media (max-width: 880px) {
        .re-container {
            background-image: url(../../assets/Mobile/Mobile_Landing/Hero_IMG.jpg);
        }

        .re-text {
            width: 415px !important;
            margin: auto !important;
        }

        .re-pgnum {
            margin: 25px 0 !important;
        }

        .re-spacing {
            margin: 25px 0 0 0 !important;
        }

        .form {
            margin: 50px 0 0 0 !important;
        }

        .re-title {
            margin: 15px 0 !important;
        }
    }

    @media (min-width: 881px) {
        .re-container {
            height: 1030px;
        }
    }

    .re-container {
        width: auto;
        background-image: url(../../assets/Desktop/Home_Landing/Hero_IMG.jpg);
        overflow: hidden;
    }

    .re-text {
        width: 574px;
    }

    .re-pgnum {
        margin: 45px 0;
    }

    .re-spacing {
        margin: 110px 0 0 0;
    }

    .re-panel-nav {
        margin-left: 75px;
    }
</style>


// WEBPACK FOOTER //
// src/components/home/Home.vue